import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconNewApproveComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-NewApprove${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M13.983 3.907a1 1 0 01.11 1.41L7.54 12.983a1 1 0 01-1.458.066L1.968 9.037a1 1 0 011.397-1.432l3.348 3.267 5.86-6.855a1 1 0 011.41-.11z"/></svg>;
}

const IconNewApprove = React.forwardRef(IconNewApproveComponent);
export default IconNewApprove;
